module.exports = __webpack_public_path__ + "static/media/add_fact_fourth.4649a5a7.png";